import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title = "NV Digital Marketing Agency | Maryland USA & Trincomalee Sri Lanka",
  description = "Professional digital marketing services with offices in Maryland, USA and Trincomalee, Sri Lanka. Expert in Video Editing, Full Stack Development, Graphic Design, Digital Marketing, and Content Creation. Contact us today!",
  keywords = "digital marketing, video editing, graphic design, full stack development, web development, Maryland USA, Trincomalee Sri Lanka, content creation, UI/UX design, social media marketing, SEO services",
  ogImage = "https://customer-assets.emergentagent.com/job_32f275e2-4426-4c73-b9b8-ea30afbab5b1/artifacts/s99jobdg_IMG-20250629-WA0001.jpg",
  url = "https://nvdigitalmarketing.it.com",
  type = "website"
}) => {
  const fullTitle = title.includes("NV Digital") ? title : `${title} | NV Digital Marketing Agency`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Karthipan Karunamoorthy - NV Digital Marketing Agency" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="NV Digital Marketing Agency" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Business Information */}
      <meta name="geo.region" content="US-MD;LK-52" />
      <meta name="geo.placename" content="Maryland;Trincomalee" />
      
      {/* Contact Information */}
      <meta name="contact" content="nvdigitalmaketingagency@gmail.com" />
      <meta name="phone" content="+16673699479" />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "NV Digital Marketing Agency",
          "url": url,
          "logo": ogImage,
          "description": description,
          "founder": {
            "@type": "Person",
            "name": "Karthipan Karunamoorthy"
          },
          "address": [
            {
              "@type": "PostalAddress",
              "addressLocality": "Maryland",
              "addressRegion": "MD",
              "addressCountry": "US"
            },
            {
              "@type": "PostalAddress",
              "addressLocality": "Trincomalee",
              "addressRegion": "Eastern Province",
              "addressCountry": "LK"
            }
          ],
          "email": "nvdigitalmaketingagency@gmail.com",
          "telephone": "+16673699479",
          "sameAs": [
            "https://wa.me/16673699479",
            "https://wa.me/94755041226"
          ],
          "areaServed": [
            {
              "@type": "Place",
              "name": "Maryland, United States"
            },
            {
              "@type": "Place",
              "name": "Trincomalee, Sri Lanka"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Digital Marketing Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Video Editing",
                  "description": "Professional video editing services with DaVinci Resolve and CapCut"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Full Stack Development",
                  "description": "End-to-end web development solutions"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Graphic Design",
                  "description": "Creative graphic design services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Digital Marketing",
                  "description": "Strategic digital marketing campaigns"
                }
              }
            ]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
